import { render, staticRenderFns } from "./TextStyle.vue?vue&type=template&id=4b76a8db&"
import script from "./TextStyle.vue?vue&type=script&lang=js&"
export * from "./TextStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports